import axios from 'axios';

const getProjects = async () => {
    const resp = await axios.get('https://api.github.com/users/Khangaroooo/repos');
    return resp.data;
};

export default {
    getProjects,
}